import { cn } from '../../lib/cn'

interface ClubCardProps {
  children: React.ReactNode
  /** Pine ground instead of parchment — marks itself `.on-pine` for focus rings. */
  inverted?: boolean
  className?: string
}

/**
 * A cut of club stationery: near-white parchment, a hairline ink border, and
 * the club's square 5px corner. The neutral container behind most content.
 *
 * `inverted` flips it to pine for the emphasis card (the featured tier, the
 * voice panel). It carries `.on-pine` so any control inside picks up the gilt
 * focus ring — see the `--club-focus` note in fireside.css.
 */
export function ClubCard({ children, inverted = false, className }: ClubCardProps) {
  return (
    <div
      className={cn(
        'rounded-club-lg border',
        inverted
          ? 'on-pine border-pine bg-pine text-paper'
          : 'border-ink/15 bg-parchment text-ink',
        className,
      )}
    >
      {children}
    </div>
  )
}
